import React from 'react';
import cn from 'classnames';
import proptypes from 'prop-types';
const { bool } = proptypes;
import styles from './loading-indicator.module.scss';

export const LoadingIndicator = ({
  centered,
}) => (
  <div
    data-testid="loading-indicator"
    className={cn(
      styles.spinner,
      centered && styles.centered,
    )}
  />
);

LoadingIndicator.propTypes = {
  centered: bool,
};

LoadingIndicator.defaultProps = {
  centered: true
};